import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const contractsGridColumns: GridColumnConfig[] = [
  {
    title: 'Contract ID',
    field: 'contractID',
    filter: 'text',
    searchable: true,
    hide: true,
  },
  {
    title: 'Contract Name',
    field: 'contractName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Start Date',
    field: 'contractStartDate',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'End Date',
    field: 'contractEndDate',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Contract Files',
    field: 'fileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded By',
    field: 'uploadedByFullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded On',
    field: 'uploadedOn',
    filter: 'text',
    searchable: true,
  },
];
